import React, { FC } from "react";
import { PageButton } from "./PageButton";
import { PageButtons } from "./PageButtons";
import PageSelectorStyle from "./selectorStyle.scss";

interface TruncatedButtonsProps {
    readonly totalPages: number;
    readonly selectedPage: number;
    readonly slots: number;
    onPageSelected(page: number): void;
}

export const TruncatedPageButtons: FC<TruncatedButtonsProps> = props => {
    const { totalPages, selectedPage, onPageSelected } = props;
    let middleRangeStart = selectedPage;
    let middleRangeEnd = selectedPage;

    let hasFirst = false;
    let hasLast = false;
    let hasMiddle = false;
    let hasLeftEllipsis = false;
    let hasRightEllipsis = false;

    let slots = Math.max(0, props.slots);
    if (slots) {
        hasMiddle = true;
        slots--;
    }
    if (slots && selectedPage > 2) {
        hasLeftEllipsis = true;
        slots--;
    }
    if (slots && selectedPage < totalPages - 1) {
        hasRightEllipsis = true;
        slots--;
    }
    if (slots && selectedPage > 1) {
        hasFirst = true;
        slots--;
    }
    if (slots && selectedPage < totalPages) {
        hasLast = true;
        slots--;
    }

    let leftAvailable = Math.max(0, middleRangeStart - 2); // how much we can grow to the left
    let rightAvailable = Math.max(0, totalPages - middleRangeEnd - 1);  // how much we can grow to the right
    const commonAvailable = Math.min(Math.floor(slots / 2), leftAvailable, rightAvailable); // how much we can grow in both directions equally
    middleRangeStart -= commonAvailable;
    middleRangeEnd += commonAvailable;
    slots -= 2 * commonAvailable;

    leftAvailable -= commonAvailable;
    rightAvailable -= commonAvailable;

    leftAvailable = Math.min(slots, leftAvailable);
    middleRangeStart -= leftAvailable;
    slots -= leftAvailable;

    rightAvailable = Math.min(slots, rightAvailable);
    middleRangeEnd += rightAvailable;
    slots -= rightAvailable;
    // now slots should get to zero

    if (hasLeftEllipsis && middleRangeStart === 3) {
        middleRangeStart--;
        hasLeftEllipsis = false;
    }

    if (hasRightEllipsis && (middleRangeEnd === totalPages - 2)) {
        middleRangeEnd++;
        hasRightEllipsis = false;
    }

    return <>
        {hasFirst && <PageButton
            current={selectedPage === 1}
            page={1}
            onClick={onPageSelected}
        />}
        {hasLeftEllipsis && <TruncatedPageSeparator />}
        {hasMiddle && <PageButtons
            min={middleRangeStart}
            max={middleRangeEnd}
            current={selectedPage}
            onPageSelected={onPageSelected}
        />}
        {hasRightEllipsis && <TruncatedPageSeparator />}
        {hasLast && <PageButton
            current={selectedPage === totalPages}
            page={totalPages}
            onClick={onPageSelected}
        />}
    </>;
};

export const TruncatedPageSeparator: FC<{}> = () => {
    return <span className={PageSelectorStyle.separator}>. . .</span>;
};

